module.exports = __webpack_public_path__ + "img/undraw_Artificial_intelligence_re_enpp.bcfe599b.svg";